export default {
  props: {
    minDate: {
      type: String,
      required: false,
      default: '2018-01-01',
    },
    maxDate: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    allowedDates(val) {
      if (this.minDate) {
        if (new Date(val).getTime() < new Date(this.minDate).getTime()) {
          return false;
        }
      }
      if (this.maxDate) {
        if (new Date(val).getTime() > new Date(this.maxDate).getTime()) {
          return false;
        }
      }
      return true;
    },
  },
};
